import { createReducer } from '@reduxjs/toolkit';
import {
  getOfferSuccessResponse,
  getOfferDocumentSuccessResponse,
  setTakeLoanSubmitFlag
} from 'actionCreators/offer';

const offerReducer = createReducer({
  offerInfo: null,
  preContractHtml: null,
  preContractPdf: null,
  loanAgreementHtml: null,
  loanAgreementPdf: null,
  preContractDocId: null,
  loanAgreementDocId: null,
  takeLoanSubmitted: false
}, (builder) => {
  builder.addCase(getOfferSuccessResponse, (state, action) => {
    state.offerInfo = action.payload.data.offers;
  });

  builder.addCase(getOfferDocumentSuccessResponse, (state, action) => {
    const {
      docParam: { type, format, docId },
      response
    } = action.payload;

    if (type === 'PreContractNotification') {
      if (format === 'HTML') {
        state.preContractHtml = response;
      } else if (format === 'PDF') {
        state.preContractPdf = response;
        state.preContractDocId = docId;
      }
    } else if (type === 'LoanAgreement') {
      if (format === 'HTML') {
        state.loanAgreementHtml = response;
      } else if (format === 'PDF') {
        state.loanAgreementPdf = response;
        state.loanAgreementDocId = docId;
      }
    }
  });

  builder.addCase(setTakeLoanSubmitFlag, (state, action) => {
    state.takeLoanSubmitted = action.payload;
  });
});

export { offerReducer };
